import React, { useEffect, useState } from "react";
import "./Perfil.css";
const API_URL = process.env.REACT_APP_API_URL;


const Perfil = () => {
  const [perfil, setPerfil] = useState({
    nome: "",
    sobrenome: "",
    celular: "",
    email: "",
    cpf: "",
    codigoPagseguro: "",
    codigoMercadoPago: "",
  });
  const [msg, setMsg] = useState("");

  useEffect(() => {
    const token = localStorage.getItem("token");

    fetch(`${API_URL}/auth/me`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${token}`,
      },
      credentials: "include",
    })
      .then((res) => {
        if (!res.ok) throw new Error("Erro ao buscar perfil");
        return res.json();
      })
      .then((data) => setPerfil(data))
      .catch((err) => {
        console.error(err);
        setMsg("Erro ao carregar perfil");
      });
  }, []);

  const aplicarMascaraCelular = (valor) => {
    valor = valor.replace(/\D/g, "");
    valor = valor.replace(/^(\d{2})(\d)/g, "($1) $2");
    valor = valor.replace(/(\d{5})(\d)/, "$1-$2");
    return valor;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    let valor = value;

    if (name === "celular") {
      valor = aplicarMascaraCelular(value);
    }

    setPerfil({ ...perfil, [name]: valor });
  };

  const handleAtualizar = async () => {
    const token = localStorage.getItem("token");

    try {
      const response = await fetch(`${API_URL}/auth/me`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
        credentials: "include",
        body: JSON.stringify({
          nome: perfil.nome,
          sobrenome: perfil.sobrenome,
          celular: perfil.celular,
          codigoPagseguro: perfil.codigoPagseguro,
          codigoMercadoPago: perfil.codigoMercadoPago,
        }),
      });

      if (response.ok) {
        setMsg("Perfil atualizado com sucesso!");
      } else {
        setMsg("Erro ao atualizar perfil");
      }
    } catch (error) {
      console.error(error);
      setMsg("Erro de conexão");
    }
  };

  return (
    <div className="perfil-container">
      <div className="perfil-box">
        <h2>Meus Dados</h2>

        <input
          name="nome"
          placeholder="Nome"
          value={perfil.nome}
          onChange={handleChange}
        />
        <input
          name="sobrenome"
          placeholder="Sobrenome"
          value={perfil.sobrenome}
          onChange={handleChange}
        />
        <input
          name="celular"
          placeholder="Celular"
          value={perfil.celular}
          onChange={handleChange}
          maxLength="15"
        />
        <input
          name="codigoMercadoPago"
          placeholder="Código Mercado Pago"
          value={perfil.codigoMercadoPago || ""}
          onChange={handleChange}
        />
        <input
          name="email"
          placeholder="Email"
          value={perfil.email}
          disabled
          className="disabled-input"
        />
        <input
          name="cpf"
          placeholder="CPF"
          value={perfil.cpf}
          disabled
          className="disabled-input"
        />

        <button onClick={handleAtualizar}>Atualizar Perfil</button>

        {msg && (
          <p className={`perfil-msg ${msg.includes("Erro") ? "erro" : ""}`}>
            {msg}
          </p>
        )}
      </div>
    </div>
  );
};

export default Perfil;
